import { Button, Card, CardContent, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { HighlightedText, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

type Props = {
  containerJourneyId: number
  containerNumber: string
  highlightText: string
  onUpdatePosition: (journeyId: number) => void
}

export const YardClerkJourneyCard: FC<Props> = observer(
  ({ containerJourneyId, containerNumber, highlightText, onUpdatePosition }) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    return (
      <Card>
        <CardContent>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'initial', sm: 'center' }}
            justifyContent='space-between'
            gap={2}
          >
            <Typography variant='h3'>
              <HighlightedText highlight={highlightText} color={theme.palette.info.main}>
                {containerNumber}
              </HighlightedText>
            </Typography>

            <Button variant='contained' onClick={() => onUpdatePosition(containerJourneyId)}>
              {t('updatePosition', 'Update position')}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    )
  },
)
